import React, { useState } from "react";
import { Card, Space, Button } from "@masterteam/mt-design-react";

import AsyncSvg from "../../../AsyncSvg";
import SummaryCharts from "../../SummaryCharts";
import StrategicObjectives from "../../StrategicObjectives";
import { useIsAr } from "../../../../Hooks";

import valueIcon from "../../../../assets/images/values.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/images/arrowpointdwn.svg";

import "./style.scss";

const Theme = ({ item, kpiStatuses, projectStatuses }) => {
  const [isAr] = useIsAr();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div key={item.ID} className="theme-wrapper">
      <div key={item.ID} className="theme-wrapper__header">
        <Card
          style={{
            width: 64,
            height: 64,
            backgroundColor: item.Color,
            position: "absolute",
          }}
        />

        <Card
          className="theme-wrapper__item-card"
          style={{
            backgroundColor: "white",
            color: "inherit",
          }}
        >
          <Space align="center">
            <AsyncSvg
              defaultSvg={valueIcon}
              attachment={item.Attachment}
              color={item.Color}
              style={{ width: 24, height: 24 }}
            />

            <div>{isAr ? item?.ArabicName : item?.EnglishName}</div>
          </Space>
          <Button
            variant="dark"
            shape="circle"
            backgroundColor="white"
            fill=""
            Icon={ArrowIcon}
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
          />
        </Card>
      </div>

      {isOpen ? (
        <Space
          direction="vertical"
          className="theme-wrapper__body"
          size="medium"
        >
          <SummaryCharts
            strategy={item}
            kpiStatuses={kpiStatuses}
            projectStatuses={projectStatuses}
            chartTitle1="dashboards.theme-kpis-performance"
            chartTitle2="dashboards.theme-projects-performance"
          />

          <StrategicObjectives
            data={item}
            kpiStatuses={kpiStatuses}
            projectStatuses={projectStatuses}
          />
        </Space>
      ) : null}
    </div>
  );
};

export default Theme;
